import React from "react";
import AuthGateway from "../components/AuthGateway/AuthGateway";

export default function RegisterV2() {
  return <AuthGateway mode="signup" />;
}


